<template>
	<v-dialog transition="scroll-x-reverse-transition" max-width="1100">
		<template #activator="{ on, attrs }">
			<v-btn
				color="secondary"
				dark
				rounded
				elevation="0"
				class="font-weight-bold"
				v-bind="attrs"
				v-on="on">
				<v-icon left>mdi-bank</v-icon>
				New Client
			</v-btn>
		</template>
		<template #default="dialogCreate">
			<v-card>
				<v-card-title>
					<div>Create Client</div>
					<v-icon right class="ml-auto theme--dark" @click="dialogCreate.value = false">mdi-close</v-icon>
				</v-card-title>
				<v-divider class="mb-5" />
				<v-card-text>
					<client-form @success="dialogCreate.value = false" />
				</v-card-text>
			</v-card>
		</template>
	</v-dialog>
</template>
<script>
import Backend from '@/Layouts/Backend'
import ClientForm from './Form'

export default {
	components: { ClientForm },
	layout: Backend,
	props: {
		//
	},
	data () {
		return {
			types: []
		}
	},
	mounted () {
		//
	},
	methods: {
		//
	}
}
</script>
